import { render, staticRenderFns } from "./CalendarItemCreate.vue?vue&type=template&id=0c21da1e"
import script from "./CalendarItemCreate.vue?vue&type=script&lang=js"
export * from "./CalendarItemCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports